module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    teaser\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbf10b2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/teaser/Teaser.vue
// module id = 2138
// module chunks = 0